/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRosterTournamentHistoryItemDtoSchema = z.object({
  tournamentId: z.string().nullish(),
  name: z.string().nullish(),
  year: z.string().nullish(),
  position: z.string().nullish(),
  prize: z.optional(z.number()),
});
